// src/screens/HomeScreen.jsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { getProgress, getRewardLevel } from '../services/authService';
import { GRUPO_WHATSAPP_URL } from '../config/links';

const WA_GROUP = GRUPO_WHATSAPP_URL;
const WEBSITE  = 'https://clicktravelagency.com.br/';

export default function HomeScreen({ onNavigate }) {
  const { user } = useAuth();
  const firstName = user?.name?.split(' ')[0] || 'Viajero';
  const clicks = user?.clicks || 0;
  const progress = getProgress(clicks);
  const rewardLevel = getRewardLevel(clicks);

  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Buenos días' : hour < 19 ? 'Buenas tardes' : 'Buenas noches';

  return (
    <div className="page" style={{ paddingTop: 24 }}>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <p style={{ fontSize: 13, color: 'var(--muted)' }}>{greeting} 👋</p>
          <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--white)' }}>{firstName}</h2>
        </div>
        <button onClick={() => onNavigate('clicks')} style={{
          background: 'linear-gradient(135deg, var(--orange), var(--gold))',
          border: 'none', borderRadius: 12, padding: '8px 14px',
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          boxShadow: '0 4px 16px rgba(255,107,0,0.3)',
        }}>
          <span style={{ fontSize: 18, fontWeight: 800, color: 'white', lineHeight: 1 }}>{clicks}</span>
          <span style={{ fontSize: 9, fontWeight: 700, color: 'rgba(255,255,255,0.85)', letterSpacing: 1 }}>CLICKs</span>
        </button>
      </div>

      {/* Hero banner */}
      <div style={{
        background: 'linear-gradient(135deg, #0F2A4A 0%, #1A1A00 100%)',
        borderRadius: 20, padding: '24px 20px',
        border: '1px solid rgba(255,184,0,0.15)',
        marginBottom: 16, position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', top: -20, right: -20, fontSize: 100, opacity: 0.05 }}>✈️</div>
        <p style={{ fontSize: 12, color: 'var(--gold)', fontWeight: 700, letterSpacing: 1, marginBottom: 6 }}>CLICK TRAVEL AGENCY</p>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 30, letterSpacing: 1, color: '#FFFFFF', lineHeight: 1.1, marginBottom: 8 }}>
          CONECTANDO CUBA<br /><span style={{ color: 'var(--orange)' }}>CON BRASIL</span>
        </h1>
        <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.5, marginBottom: 16 }}>
          Vuelos · Remesas · Recargas · Traducciones<br />Atención personalizada en español 🇨🇺🇧🇷
        </p>
        <button onClick={() => onNavigate('cuba')} style={{
          background: 'var(--orange)', color: 'white', fontWeight: 700,
          fontSize: 13, borderRadius: 8, padding: '10px 20px',
          boxShadow: '0 4px 16px rgba(255,107,0,0.4)',
        }}>Ver todos los servicios →</button>
      </div>

      {/* Tarjeta sitio web — motor de búsqueda */}
      <a href={WEBSITE} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'block', marginBottom: 16 }}>
        <div style={{
          background: 'linear-gradient(135deg, rgba(255,107,0,0.1), rgba(255,184,0,0.06))',
          border: '1px solid rgba(255,107,0,0.3)',
          borderRadius: 16, padding: '16px 18px',
          display: 'flex', alignItems: 'center', gap: 14,
        }}>
          <div style={{
            width: 48, height: 48, flexShrink: 0,
            background: 'linear-gradient(135deg, var(--orange), var(--gold))',
            borderRadius: 12, display: 'flex', alignItems: 'center',
            justifyContent: 'center', fontSize: 24,
            boxShadow: '0 4px 12px rgba(255,107,0,0.3)',
          }}>🌐</div>
          <div style={{ flex: 1 }}>
            <p style={{ fontSize: 13, fontWeight: 800, color: 'var(--white)', marginBottom: 3 }}>
              Busca vuelos, hoteles y más
            </p>
            <p style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.5 }}>
              Compara precios en tiempo real y compra en parcelas directamente en nuestro sitio.
            </p>
          </div>
          <span style={{ color: 'var(--orange)', fontSize: 18, flexShrink: 0 }}>→</span>
        </div>
      </a>

      {/* Quiénes somos */}
      <div className="card" style={{ marginBottom: 16, borderLeft: '3px solid var(--orange)' }}>
        <p style={{ fontSize: 11, color: 'var(--orange)', fontWeight: 700, letterSpacing: 1, marginBottom: 8 }}>QUIÉNES SOMOS</p>
        <p style={{ fontSize: 13, color: 'var(--off-white)', lineHeight: 1.7 }}>
          Agencia registrada en Curitiba-PR, especializada en la comunidad cubana y latinoamericana en Brasil. Atención en español, con confianza y experiencia.
        </p>
      </div>

      {/* CLICKs progress */}
      {rewardLevel ? (
        <div onClick={() => onNavigate('clicks')} style={{
          background: 'linear-gradient(135deg, rgba(255,184,0,0.12), rgba(255,107,0,0.08))',
          border: '1px solid rgba(255,184,0,0.3)',
          borderRadius: 16, padding: 16, cursor: 'pointer', marginBottom: 16,
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <p style={{ fontSize: 12, color: 'var(--gold)', fontWeight: 700 }}>🎉 ¡PREMIO DISPONIBLE!</p>
              <p style={{ fontSize: 13, color: 'var(--white)', marginTop: 4 }}>Alcanzaste {rewardLevel} CLICKs. Toca para canjear.</p>
            </div>
            <span style={{ fontSize: 22, color: 'var(--gold)' }}>→</span>
          </div>
        </div>
      ) : (
        <div onClick={() => onNavigate('clicks')} className="card" style={{ cursor: 'pointer', marginBottom: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <p style={{ fontSize: 13, fontWeight: 700, color: 'var(--white)' }}>⭐ Mis CLICKs</p>
            <p style={{ fontSize: 12, color: 'var(--muted)' }}>{progress.next - clicks} para el próximo nivel</p>
          </div>
          <div style={{ background: 'var(--navy)', borderRadius: 4, height: 6, overflow: 'hidden' }}>
            <div style={{ width: `${Math.round(progress.pct * 100)}%`, height: '100%', background: 'linear-gradient(90deg, var(--orange), var(--gold))', borderRadius: 4, transition: 'width 0.6s ease' }} />
          </div>
          <p style={{ fontSize: 11, color: 'var(--muted)', marginTop: 6 }}>{clicks} / {progress.next} CLICKs</p>
        </div>
      )}

      {/* Acceso rápido */}
      <p className="section-label" style={{ marginBottom: 12 }}>ACCESO RÁPIDO</p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 80 }}>
        {[
          { icon: '📱', label: 'Recargas',      sub: 'Desde R$ 11',      service: 'recargas' },
          { icon: '💸', label: 'Remesas',       sub: 'BRL → CUP',        service: 'remesas' },
          { icon: '✈️', label: 'Vuelos',        sub: 'Cotización gratis', service: 'vuelos' },
          { icon: '📄', label: 'Traducciones',  sub: 'Desde R$ 100',     service: 'traducciones' },
        ].map(item => (
          <button key={item.label} onClick={() => onNavigate('cuba', item.service)} style={{
            background: 'var(--navy-card)', border: '1px solid var(--navy-border)',
            borderRadius: 14, padding: '14px 12px', textAlign: 'left', transition: 'all 0.2s',
          }}
          onMouseOver={e => e.currentTarget.style.borderColor = 'var(--orange)'}
          onMouseOut={e => e.currentTarget.style.borderColor = 'var(--navy-border)'}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>{item.icon}</div>
            <p style={{ fontSize: 13, fontWeight: 700, color: 'var(--white)' }}>{item.label}</p>
            <p style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{item.sub}</p>
          </button>
        ))}
      </div>

      {/* Botón flotante WhatsApp */}
      <a
        href={WA_GROUP}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: 90,
          right: 20,
          zIndex: 100,
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: '#25D366',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 20px rgba(37,211,102,0.5)',
          textDecoration: 'none',
        }}
      >
        {/* Ícono WhatsApp SVG */}
        <svg width="30" height="30" viewBox="0 0 24 24" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>

    </div>
  );
      }
